import { INavData } from '@coreui/angular';

export const navItems1: INavData[] = [
      {
        name: 'Dashboard',
        url: '/courier/dashboard',
        icon: 'icon-puzzle'
      },
      {
        name: 'Entries',
        url: '/courier/entry',
        icon: 'icon-puzzle',
        children: [
          
          {
            name: 'Shipment Booking',
            url: '/courier/entry/bookingold',
            icon: 'icon-puzzle'
          }
        ]
      },
      {
        name: 'Reports',
        url: '/courier/report',
        icon: 'icon-puzzle',
        children: [
          
          {
            name: 'Status',
            url: '/courier/report/status',
            icon: 'icon-puzzle'
          },
         
          {
            name: 'Booking Statement',
            url: '/courier/report/bookingstatement',
            icon: 'icon-puzzle'
          },
          
        ]},
        {
          name: 'Log Out',
          url: 'login',
          icon: 'icon-puzzle'
        }
    
  
  
];
